import _ from 'lodash'
import axios from 'axios'
import { uuid } from 'vue-uuid'

import * as types from '../types'
import router from '../../router'

const startingMaterialId = uuid.v4()

const state = {
  cart: getInitialCart(),
  savingOrder: null,
  savingOrderRedirect: false,
  loadingMaterial: false,
  loadingQuotation: false,
  isLoadingQuotationToTool: false,
  orderError: false,
  calculatingStatus: null,
  calculatingError: false,
  priceDetails: null,
  sawingScheduleDetails: null
}

const getters = {
  cartReference: (state) => {
    return state.cart.reference
  },
  internalReference: (state) => {
    return state.cart.internalReference
  },
  restMaterials: (state) => {
    return state.cart.restmaterials
  },
  material: (state, getters) => {
    return getters.cartMaterial(state.cart.selectedMaterial)
  },
  cart: (state) => {
    return state.cart
  },
  cartMaterials: (state) => {
    return state.cart.materials
  },
  cartMaterial: (state) => (id) => {
    return state.cart.materials.find(material => material.id === id)
  },
  selectedMaterial: (state) => {
    return state.cart.selectedMaterial
  },
  loadingMaterial: (state) => {
    return state.loadingMaterial
  },
  savingOrder: (state) => {
    return state.savingOrder
  },
  savingOrderRedirect: (state) => {
    return state.savingOrderRedirect
  },
  loadingQuotation: (state) => {
    return state.loadingQuotation
  },
  filterDeliveryProgram: (state, getters) => {
    let material = getters.cartMaterial(state.cart.selectedMaterial)
    return material.filterDeliveryProgram
  },
  filterFirst: (state, getters) => {
    let material = getters.cartMaterial(state.cart.selectedMaterial)
    return material.filterFirst
  },
  filterSecond: (state, getters) => {
    let material = getters.cartMaterial(state.cart.selectedMaterial)
    return material.filterSecond
  },
  filterThird: (state, getters) => {
    let material = getters.cartMaterial(state.cart.selectedMaterial)
    return material.filterThird
  },
  materialBruto: (state, getters) => {
    let material = getters.cartMaterial(state.cart.selectedMaterial)
    return material.bruto
  },
  materialThickness: (state, getters) => {
    let material = getters.cartMaterial(state.cart.selectedMaterial)
    return material.thickness
  },
  materialDimensions: (state, getters) => {
    let material = getters.cartMaterial(state.cart.selectedMaterial)
    return {
      total_thickness: material.total_thickness,
      total_length: material.total_length,
      total_width: material.total_width
    }
  },
  materialSide: (state, getters) => (side) => {
    if (parseInt(side) === 2) {
      return getters.materialSide2
    }
    return getters.materialSide1
  },
  materialSide1: (state, getters) => {
    let material = getters.cartMaterial(state.cart.selectedMaterial)
    return material.side1
  },
  materialSide2: (state, getters) => {
    let material = getters.cartMaterial(state.cart.selectedMaterial)
    return material.side2
  },
  materialFinish: (state, getters) => {
    let material = getters.cartMaterial(state.cart.selectedMaterial)
    return material.finish
  },
  materialProduct: (state, getters) => {
    let material = getters.cartMaterial(state.cart.selectedMaterial)
    return material.product
  },
  materialCode: (state, getters) => {
    let material = getters.cartMaterial(state.cart.selectedMaterial)
    return material.code
  },
  panels: (state, getters) => {
    let material = getters.cartMaterial(state.cart.selectedMaterial)
    return material.panels
  },
  totalPanelCount: (state, getters) => {
    // return state.cart.materials.reduce((i, material) => material.panels.length, 0)
    return state.cart.materials.reduce((total, material) => {
      return total + material.panels.reduce((total, panel) => {
        return total + parseInt(panel.amount)
      }, 0)
    }, 0)
  },
  calculatingStatus: (state) => {
    return state.calculatingStatus
  },
  calculatingError: (state) => {
    return state.calculatingError
  },
  isLoadingQuotationToTool: (state) => {
    return state.isLoadingQuotationToTool
  },
  orderError: (state) => {
    return state.orderError
  },
  priceDetails: (state) => {
    return state.priceDetails
  },
  sawingScheduleDetails: (state) => (id) => {
    return !state.sawingScheduleDetails || !state.sawingScheduleDetails[id] ? null : state.sawingScheduleDetails[id]
  },
  disablePanelInput: (state, getters) => {
    let material = getters.cartMaterial(state.cart.selectedMaterial)
    return material.disablePanelInput
  },
  disableExcelUpload: (state, getters) => {
    let material = getters.cartMaterial(state.cart.selectedMaterial)
    return material.disableExcelUpload
  }
}

const mutations = {
  [types.MUTATE_CART_REFERENCE]: (state, reference) => {
    state.cart.reference = reference
  },
  [types.MUTATE_INTERNAL_REFERENCE]: (state, internalReference) => {
    state.cart.internalReference = internalReference
  },
  [types.MUTATE_CART_RESTMATERIALS]: (state, restmaterials) => {
    state.cart.restmaterials = restmaterials
  },
  [types.MUTATE_CART]: (state, cart) => {
    state.cart = cart
  },
  [types.MUTATE_ADD_MATERIAL]: (state, material) => {
    state.cart.materials.push(material)
    state.calculatingStatus = null
  },
  [types.MUTATE_MATERIALS]: (state, materials) => {
    state.cart.materials = materials
    state.calculatingStatus = null
  },
  [types.MUTATE_SELECTED_MATERIAL]: (state, materialId) => {
    state.cart.selectedMaterial = materialId
  },
  [types.MUTATE_FILTER_DELIVERYPROGRAM]: (state, filterDeliveryProgram) => {
    let material = getMaterial(state)
    material.filterDeliveryProgram = filterDeliveryProgram
  },
  [types.MUTATE_FILTER_FIRST]: (state, filterFirst) => {
    let material = getMaterial(state)
    material.filterFirst = filterFirst
  },
  [types.MUTATE_FILTER_SECOND]: (state, filterSecond) => {
    let material = getMaterial(state)
    material.filterSecond = filterSecond
  },
  [types.MUTATE_FILTER_THIRD]: (state, filterThird) => {
    let material = getMaterial(state)
    material.filterThird = filterThird
  },
  [types.MUTATE_BRUTO]: (state, bruto) => {
    let material = getMaterial(state)
    material.bruto = bruto
  },
  [types.MUTATE_THICKNESS]: (state, thickness) => {
    let material = getMaterial(state)
    if (material.thickness !== thickness) {
      state.calculatingStatus = null
    }
    material.thickness = thickness
  },
  [types.MUTATE_PRODUCT]: (state, product) => {
    let material = getMaterial(state)
    material.product = product
  },
  [types.MUTATE_CODE]: (state, code) => {
    let material = getMaterial(state)
    material.code = code
  },
  [types.MUTATE_SIDE_1]: (state, side) => {
    let material = getMaterial(state)
    if (material.side1 !== side) {
      state.calculatingStatus = null
    }
    material.side1 = side
  },
  [types.MUTATE_SIDE_2]: (state, side) => {
    let material = getMaterial(state)
    if (material.side2 !== side) {
      state.calculatingStatus = null
    }
    material.side2 = side
  },
  [types.MUTATE_FINISH]: (state, finish) => {
    let material = getMaterial(state)
    if (material.finish !== finish) {
      state.calculatingStatus = null
    }
    material.finish = finish
  },
  [types.MUTATE_IS_LOADING_MATERIAL]: (state, loadingMaterial) => {
    state.loadingMaterial = loadingMaterial
  },
  [types.MUTATE_TOTAL_THICKNESS]: (state, thickness) => {
    let material = getMaterial(state)
    material.total_thickness = parseFloat(thickness)
  },
  [types.MUTATE_TOTAL_LENGTH]: (state, length) => {
    let material = getMaterial(state)
    material.total_length = parseFloat(length)
  },
  [types.MUTATE_TOTAL_WIDTH]: (state, width) => {
    let material = getMaterial(state)
    material.total_width = parseFloat(width)
  },
  [types.MUTATE_TOTAL_DIMENSIONS]: (state, dimensions) => {
    let material = getMaterial(state)
    material.total_dimensions = dimensions
  },
  [types.MUTATE_PANELS]: (state, panels) => {
    let material = getMaterial(state)
    material.panels = panels
  },
  [types.MUTATE_SAVING_ORDER]: (state, savingOrder) => {
    state.savingOrder = savingOrder
  },
  [types.MUTATE_SAVING_ORDER_REDIRECT]: (state, savingOrderRedirect) => {
    state.savingOrderRedirect = savingOrderRedirect
  },
  [types.MUTATE_LOAD_QUOTATION]: (state, loadingQuotation) => {
    state.loadingQuotation = loadingQuotation
  },
  [types.MUTATE_CALCULATING_STATUS]: (state, calculatingStatus) => {
    state.calculatingStatus = calculatingStatus
  },
  [types.MUTATE_CALCULATING_ERROR]: (state, calculatingError) => {
    state.calculatingError = calculatingError
  },
  [types.MUTATE_IS_LOADING_QUOTATION_TO_TOOL]: (state, isLoadingQuotationToTool) => {
    state.isLoadingQuotationToTool = isLoadingQuotationToTool
  },
  [types.MUTATE_VALIDATING_PANEL_ROWS]: (state, isLoadingQuotationToTool) => {
    // TODO: review this method, wrong property?
    state.isLoadingQuotationToTool = isLoadingQuotationToTool
  },
  [types.MUTATE_ORDER_ERROR]: (state, orderError) => {
    state.orderError = orderError
  },
  [types.MUTATE_PRICE_DETAILS]: (state, priceDetails) => {
    state.priceDetails = priceDetails
  },
  [types.MUTATE_SAWING_SCHEDULE_DETAILS]: (state, sawingScheduleDetails) => {
    state.sawingScheduleDetails = sawingScheduleDetails
  },
  [types.MUTATE_DISABLE_PANEL_INPUT]: (state, disablePanelInput) => {
    let material = getMaterial(state)
    material.disablePanelInput = disablePanelInput
  },
  [types.MUTATE_DISABLE_EXCEL_UPLOAD]: (state, disableExcelUpload) => {
    let material = getMaterial(state)
    material.disableExcelUpload = disableExcelUpload
  }
}

const actions = {
  [types.SAVE_ORDER]: ({ commit, dispatch }, cart) => {
    commit(types.MUTATE_SAVING_ORDER, true)
    localStorage.setItem('cart', JSON.stringify(cart))

    return axios
      .post('/tool/save', cart)
      .then(res => {
        commit(types.MUTATE_INTERNAL_REFERENCE, res.data.internalReference)
        // Also store the cart in the localStorage
        localStorage.setItem('cart', JSON.stringify(cart))
        return true
      })
      .catch(error => {
        // Log error
        console.log(error)
        if (error.response.status === 401) {
          dispatch(types.CLEAR_AUTH)
        }
        return false
      })
  },
  [types.SAVE_ORDER_REDIRECT]: ({ commit, dispatch }, cart) => {
    commit(types.MUTATE_SAVING_ORDER_REDIRECT, true)
    localStorage.setItem('cart', JSON.stringify(cart))
    let doRedirect = true

    return axios
      .post('/tool/save', cart)
      .then(res => {
        commit(types.MUTATE_INTERNAL_REFERENCE, res.data.internalReference)
        // Also store the cart in the localStorage
        localStorage.setItem('cart', JSON.stringify(cart))
        return true
      })
      .catch(error => {
        // Log error
        console.log(error)
        if (error.response.status === 401) {
          dispatch(types.CLEAR_AUTH)
        }
        doRedirect = false
        return false
      })
      .finally(() => {
        commit(types.MUTATE_SAVING_ORDER_REDIRECT, false)
        // Redirect the user
        if (doRedirect) {
          router.push({ name: 'order' })
        }
      })
  },
  [types.SAVE_ORDER_LOCAL_STORAGE]: ({ commit }, cart) => {
    localStorage.setItem('cart', JSON.stringify(cart))
  },
  [types.TOOL_LOAD_CART_FROM_LOCAL_STORAGE]: ({ commit }) => {
    commit(types.MUTATE_IS_LOADING_QUOTATION_TO_TOOL, true)

    let cart = JSON.parse(localStorage.getItem('cart'))
    commit(types.MUTATE_CART, cart)
    commit(types.MUTATE_CALCULATING_STATUS, null)
    commit(types.MUTATE_CALCULATING_ERROR, false)
    commit(types.MUTATE_PRICE_DETAILS, null)
    localStorage.setItem('cart', JSON.stringify(cart))

    router.push({ name: 'tool' })

    commit(types.MUTATE_IS_LOADING_QUOTATION_TO_TOOL, false)
  },
  [types.ADD_MATERIAL]: ({ commit }) => {
    let material = {
      id: uuid.v4(),
      bruto: false,
      code: null,
      filterDeliveryProgram: null,
      filterFirst: null,
      filterSecond: null,
      filterThird: null,
      thickness: null,
      product: null,
      side1: null,
      side2: null,
      finish: null,
      confirmTrash: false,
      total_thickness: null,
      total_length: null,
      total_width: null,
      total_dimensions: null,
      disablePanelInput: true,
      disableExcelUpload: null,
      panels: [
        {
          id: 1,
          length: null,
          width: null,
          amount: null,
          l1: false,
          l2: false,
          b1: false,
          b2: false,
          reference: null,
          confirmTrash: false,
          valid: null
        }
      ]
    }

    commit(types.MUTATE_IS_LOADING_MATERIAL, true)
    commit(types.MUTATE_ADD_MATERIAL, material)
    commit(types.MUTATE_SELECTED_MATERIAL, material.id)
    commit(types.MUTATE_CALCULATING_STATUS, null)
    commit(types.MUTATE_CALCULATING_ERROR, false)
  },
  [types.LOAD_ORDER_FROM_IMPORT]: ({ commit, dispatch, state }, data) => {
    dispatch(types.RESET_CART)
    dispatch(types.SET_REFERENCE, data.reference)
    _.chain(data.cart)
      .map(function(material) {
        let panelCounter = 1
        let panels = _.chain(material.items)
          .each(function(panel) {
            return {
              id: panelCounter++,
              name: panel.name,
              thickness: panel.thickness,
              length: panel.length,
              width: panel.width,
              amount: panel.amount,
              l1: panel.l1,
              l2: panel.l2,
              b1: panel.b1,
              b2: panel.b2,
              reference: panel.reference,
              valid: null
            }
          }).value()
        let newMaterial = {
          id: uuid.v4(),
          bruto: material.bruto,
          code: material.id,
          filterDeliveryProgram: material.deliveryProgram,
          filterFirst: material.filter_1,
          filterSecond: material.filter_2,
          filterThird: material.filter_3,
          thickness: getThickness(material.thickness),
          product: null,
          side1: null,
          side2: null,
          finish: null,
          confirmTrash: false,
          total_thickness: material.thickness,
          total_length: material.length,
          total_width: material.width,
          total_dimensions: material.dimensions,
          panels: panels,
          disablePanelInput: false,
          disableExcelUpload: null
        }
        commit(types.MUTATE_ADD_MATERIAL, newMaterial)
        // dispatch(types.SET_MATERIAL_CODE, material.id)
      }).value()
  },
  [types.REMOVE_MATERIAL]: ({ commit, state }, material) => {
    let materials = state.cart.materials

    // Remove the material
    materials = materials.filter((i) => i.id !== material.id)

    // Select the last material
    commit(types.MUTATE_IS_LOADING_MATERIAL, true)
    if (state.cart.selectedMaterial === material.id) {
      let lastMaterial = materials[materials.length - 1]
      commit(types.MUTATE_SELECTED_MATERIAL, lastMaterial.id)
    }

    commit(types.MUTATE_MATERIALS, materials)
    commit(types.MUTATE_CALCULATING_STATUS, null)
    commit(types.MUTATE_CALCULATING_ERROR, false)
  },
  [types.SELECT_MATERIAL]: ({ commit }, material) => {
    commit(types.MUTATE_IS_LOADING_MATERIAL, true)
    commit(types.MUTATE_SELECTED_MATERIAL, material.id)
  },
  [types.REMOVE_PANEL]: ({ commit, state }, panel) => {
    let material = getMaterial(state)
    let panels = material.panels.filter((i) => i.id !== panel.id)

    panels.map(function(x, i) {
      x.id = i + 1
    })

    commit(types.MUTATE_PANELS, panels)
  },
  [types.SET_REFERENCE]: ({ commit }, reference) => {
    commit(types.MUTATE_CART_REFERENCE, reference)
  },
  [types.SET_RESTMATERIALS]: ({ commit }, restmaterials) => {
    commit(types.MUTATE_CART_RESTMATERIALS, restmaterials)
  },
  [types.SET_MATERIAL_FILTER_DELIVERYPROGRAM]: ({ commit }, filter) => {
    commit(types.MUTATE_FILTER_DELIVERYPROGRAM, filter)
  },
  [types.SET_MATERIAL_FILTER_FIRST]: ({ commit }, filter) => {
    commit(types.MUTATE_FILTER_FIRST, filter)
  },
  [types.SET_MATERIAL_BRUTO]: ({ commit }, bruto) => {
    commit(types.MUTATE_BRUTO, bruto)
  },
  [types.SET_MATERIAL_FILTER_SECOND]: ({ commit }, filter) => {
    commit(types.MUTATE_FILTER_SECOND, filter)
  },
  [types.SET_MATERIAL_FILTER_THIRD]: ({ commit }, filter) => {
    commit(types.MUTATE_FILTER_THIRD, filter)
  },
  [types.SET_MATERIAL_THICKNESS]: ({ commit }, thickness) => {
    commit(types.MUTATE_THICKNESS, thickness)
  },
  [types.SET_MATERIAL_PRODUCT]: ({ commit }, product) => {
    commit(types.MUTATE_PRODUCT, product)
    if (product === null) {
      commit(types.MUTATE_CODE, null)
    }
  },
  [types.SET_MATERIAL_CODE]: ({ commit }, code) => {
    commit(types.MUTATE_CODE, code)
  },
  [types.SET_MATERIAL_SIDE]: ({ commit }, data) => {
    if (data.sideType === 2) {
      commit(types.MUTATE_SIDE_2, data.sideValue)
    } else {
      commit(types.MUTATE_SIDE_1, data.sideValue)
    }
  },
  [types.SET_MATERIAL_FINISH]: ({ commit }, finish) => {
    commit(types.MUTATE_FINISH, finish)
  },
  [types.SET_MATERIAL_TOTAL_THICKNESS]: ({ commit }, thickness) => {
    commit(types.MUTATE_TOTAL_THICKNESS, thickness)
  },
  [types.SET_MATERIAL_TOTAL_LENGTH]: ({ commit }, length) => {
    commit(types.MUTATE_TOTAL_LENGTH, length)
  },
  [types.SET_MATERIAL_TOTAL_WIDTH]: ({ commit }, width) => {
    commit(types.MUTATE_TOTAL_WIDTH, width)
  },
  [types.SET_MATERIAL_TOTAL_DIMENSIONS]: ({ commit }, dimensions) => {
    commit(types.MUTATE_TOTAL_DIMENSIONS, dimensions)
  },
  [types.LOAD_QUOTATION]: ({ commit, dispatch }, quotation) => {
    commit(types.MUTATE_IS_LOADING_QUOTATION_TO_TOOL, true)
    commit(types.MUTATE_CALCULATING_STATUS, null)
    commit(types.MUTATE_CALCULATING_ERROR, false)
    commit(types.MUTATE_PRICE_DETAILS, null)

    axios
      .post('/tool/load', {
        'quotation': quotation.id
      })
      .then(res => {
        // Push to cart & redirect to tool page
        commit(types.MUTATE_CART, res.data.cart)
        localStorage.setItem('cart', JSON.stringify(res.data.cart))
        router.push({ name: 'tool' })
      })
      .catch(error => {
        // Log error
        console.log(error)
        if (error.response.status === 401) {
          dispatch(types.CLEAR_AUTH)
        }
      })
      .finally(() => {
        commit(types.MUTATE_IS_LOADING_QUOTATION_TO_TOOL, false)
      })
  },
  [types.CALCULATE_ORDER]: ({ commit, dispatch }, cart) => {
    commit(types.MUTATE_CALCULATING_STATUS, true)

    commit(types.MUTATE_PRICE_DETAILS, null)
    commit(types.MUTATE_SAWING_SCHEDULE_DETAILS, null)
    commit(types.MUTATE_CALCULATING_ERROR, false)

    return axios
      .post('/tool/calculate', {
        'cart': cart
      })
      .then(res => {
        commit(types.MUTATE_PRICE_DETAILS, {
          'material_price': res.data.materialPrice,
          'transport_price': res.data.transportPrice,
          'total_price': res.data.totalPrice,
          'vat': res.data.vat,
          'total_vat': res.data.totalVat
        })

        commit(types.MUTATE_SAWING_SCHEDULE_DETAILS, res.data.sawingschedule)
        return true
      })
      .catch(error => {
        // Log error
        console.log('Calculate error: ', error)
        commit(types.MUTATE_CALCULATING_STATUS, false)
        commit(types.MUTATE_CALCULATING_ERROR, 'Er heeft zich een fout voorgedaan bij het maken van een berekening. Probeer het later nog eens.')
        if (error.response.status === 401) {
          dispatch(types.CLEAR_AUTH)
        }
        return false
      })
      .finally(() => {
        commit(types.MUTATE_CALCULATING_STATUS, false)
      })
  },
  [types.RESET_CART]: ({ commit }) => {
    // Create a new initialCart, if we use the same one we use in the state it will not reset properly
    let initialCart = getInitialCart()

    commit(types.MUTATE_CART, initialCart)
    commit(types.MUTATE_CART_REFERENCE, '')
    commit(types.MUTATE_CALCULATING_STATUS, null)
    localStorage.setItem('cart', JSON.stringify(initialCart))
  },
  [types.SET_DISABLE_PANEL_INPUT]: ({ commit }) => {
    let material = getMaterial(state)
    if (material.bruto && material.side1 && material.side2) {
      commit(types.MUTATE_DISABLE_PANEL_INPUT, false)
    } else if (material.code && material.finish) {
      if (material.filterFirst.indexOf('HPL') !== -1) {
        if (material.side1 && material.side2) {
          commit(types.MUTATE_DISABLE_PANEL_INPUT, false)
        }
      } else {
        commit(types.MUTATE_DISABLE_PANEL_INPUT, false)
      }
    }
  },
  [types.SET_DISABLE_EXCEL_UPLOAD]: ({ commit }, allowUpload) => {
    commit(types.MUTATE_DISABLE_EXCEL_UPLOAD, allowUpload)
  }
}

/**
 * @param state
 * @returns {T}
 */
function getMaterial(state) {
  let selectedMaterial = state.cart.selectedMaterial
  return state.cart.materials.find(material => material.id === selectedMaterial)
}

function getThickness(thickness) {
  return {
    code: thickness,
    label: thickness + ' mm'
  }
}

function getInitialCart() {
  return {
    // The order reference
    reference: '',
    // Internal reference in backend
    internalReference: null,
    // The currently selected material
    selectedMaterial: startingMaterialId,
    // Restmaterial
    restmaterials: false,
    // All the materials the client has added to their cart
    materials: [
      {
        id: startingMaterialId,
        bruto: false,
        code: null,
        filterDeliveryProgram: null,
        filterFirst: null,
        filterSecond: null,
        filterThird: null,
        thickness: null,
        product: null,
        side1: null,
        side2: null,
        finish: null,
        confirmTrash: false,
        total_thickness: null,
        total_length: null,
        total_width: null,
        total_dimensions: null,
        disablePanelInput: true,
        disableExcelUpload: null,
        panels: [
          {
            id: 1,
            length: null,
            width: null,
            amount: null,
            l1: false,
            l2: false,
            b1: false,
            b2: false,
            reference: null,
            confirmTrash: false,
            valid: null
          }
        ]
      }
    ]
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
